export const TelPrefixes = {
    prefixes: [
        { country: "BG", prefix: "+359"}
    ]
}
